module.exports = __webpack_public_path__ + "img/carousel-hsp2-3.af9efe30.png";